import { type JSX, Suspense } from 'react';

import { LoadingSpinner } from '~/components/LoadingSpinner';

import { getContentComponent } from './content';

/**
 * DocsHome - Landing page for /docs route.
 * Renders the "Getting Started" content as the documentation index.
 */
export function DocsHome(): JSX.Element {
  const GettingStarted = getContentComponent('getting-started');

  if (!GettingStarted) {
    return (
      <div className="text-center py-16">
        <h1 className="text-2xl font-bold text-foreground mb-4">Documentation</h1>
        <p className="text-muted">Welcome to Compounds documentation. Content coming soon.</p>
      </div>
    );
  }

  return (
    <Suspense
      fallback={
        <div className="flex justify-center py-16">
          <LoadingSpinner />
        </div>
      }
    >
      <GettingStarted />
    </Suspense>
  );
}
